<script setup lang="ts">
const route = useRoute()

useHead({
  title: route.meta.title || "UBS",
  meta: [
    {
      name: "description",
      content: (route.meta.description as string) || "UBS"
    }
  ]
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
